import axios from 'axios-jsonp-pro';
import qs from 'qs';
import uuid from 'uuid/v4';
import _fetchJsonp from 'fetch-jsonp';
axios.defaults.timeout = 3000;
import logger from '../components/logger';

const isIgnore = code => {
  const list = [200, -2, 'VALIDATE_SUCCESS', 'FORM_USER_NOT_LOGIN'];
  // 当code存在在list内，返回true
  return list.some(item => {
    return item == code;
  });
};

const get = async url => {
  const result = await axios.get(url);
  // 如果请求的URL是CDN链接，不去做记录
  if (!isIgnore(result.data.code) && url.indexOf('alicdn.com') == -1) {
    logger &&
      logger.warn(
        `${url} 响应状态码非200`,
        {
          response: result.data,
        },
        { tags: 'ACE_SERVICES;get' }
      );
  }
  return result;
};
const post = async (url, params = {}) => {
  const result = await axios.post(url, qs.stringify(params), {
    withCredentials: true,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
  if (!isIgnore(result.data.code)) {
    logger &&
      logger.warn(
        `${url} 响应状态码非200`,
        {
          response: result.data,
          requestPrams: params,
        },
        { tags: 'ACE_SERVICES;post' }
      );
  }
  return result;
};
const getQuery = async (url, params = {}) => {
  try {
    let requestUrl = `https://query.aliyun.com/rest/${url}`;
    if (params) {
      requestUrl = `https://query.aliyun.com/rest/${url}?${qs.stringify(params)}`;
    }
    const result = await axios.get(requestUrl);
    return result.data;
  } catch (error) {
    logger && logger.fatal(`${url} 请求失败 error:${error.message}`, {}, { tags: 'ACE_SERVICES;getQuery' });
  }
};
const jsonp = async (url, params = {}) => {
  try {
    return await axios.jsonp(url, {
      params,
      prefix:
        'ace' +
        uuid()
          .replace(/-/g, '_')
          .substring(0, 10),
    });
  } catch (error) {
    return null;
  }
};
const fetchJsonp = async (url, params) => {
  const result = await _fetchJsonp(url, params);
  result.json().then(result => {
    // accountInfo.json -> 未登录是 -2
    if (!isIgnore(result.code)) {
      logger &&
        logger.warn(
          `${url} 响应状态码非200`,
          {
            response: result,
            requestPrams: params,
          },
          { tags: 'ACE_SERVICES;jsonp' }
        );
    }
  });
  return result;
};
export { get, post, getQuery, jsonp, fetchJsonp };



// WEBPACK FOOTER //
// ./src/util/request.js